var _ = {
  defaults: {
    componentSelector: '.tile__content--collapsable',
    selectors: {
      buttonTrigger: '.collapsible-trigger'
    },
    classes: {
      button: ['collapsible-trigger'],
      contentBox: ['collapsible-content']
    },
    content: {
      button: 'Details anzeigen',
      collapsed: 'Details ausblenden'
    },
    templates: {
      triggerButton: "<button class=\"btn  btn--small btn--tile btn--toggle-show btn--icon u-icon--before u-icon--show-more \"   aria-label=\"Mehr anzeigen\" type=\"button\">Details anzeigen</button >"
    },
    sizes: {
      collapse: 620,
      collapseNarrow: 350
    }
  }
};
var o = _.defaults;

var collapseContent = function collapseContent(e, collapsable) {
  collapsable.classList.toggle('collapsed');
  var button = e.target;
  button.classList.toggle('active');
  button.textContent = button.textContent === o.content.collapsed ? o.content.button : o.content.collapsed;
  button.classList.toggle('u-icon--show-more');
  button.classList.toggle('u-icon--show-less');
  e.stopPropagation();
  e.preventDefault();
};

var isCollapse = function isCollapse(collapsable) {
  // if (collapsable.classList.contains('tile__content--narrow') && collapsable.clientHeight > o.sizes.collapseNarrow) {
  //   return true;
  // }
  //   console.log(collapsable.classList.contains('no-collapse'), 'test claass');
  if (collapsable.clientHeight > o.sizes.collapse && !collapsable.classList.contains('no-collapse')) {
    return true;
  }

  return false;
};
/**
 * initialize the component
 * @export function
 */


export function init() {
  if (document.querySelector(o.componentSelector)) {
    // console.log('init collapse');
    var collapsables = document.querySelectorAll(o.componentSelector); // console.log(collapsables, 'test');

    Array.from(collapsables).forEach(function (collapsable) {
      if (isCollapse(collapsable)) {
        if (!collapsable.querySelectorAll('.btn--toggle-show').length) {
          collapsable.classList.add('collapsed');
          collapsable.insertAdjacentHTML('beforeend', o.templates.triggerButton);
          var triggerButtons = collapsable.querySelectorAll('.btn--toggle-show');
          triggerButtons.forEach(function (btn) {
            return btn.addEventListener('click', function (e) {
              return collapseContent(e, collapsable);
            });
          });
        }
      }
    });
  }
}